export const logMessage = (...messages) => {
  return messages;
}
